import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import  PRETTY from '../../assets/img/logo/PRETTYLASHED.png';

import CartCounter from '../Cart/CartCounter';

class ProductsHeader extends Component {
  render() {
    return (
      <header className="push">
        <div className="nav-container">
          <nav className="primary-nav">
            <Link to="/products">Products</Link>
            <Link to="/styles">Styles</Link>
            <Link to="/gallery">Gallery</Link>
            <Link to="/about">About</Link>
          </nav>
          <div className="logo">
            <Link to="/" className="logo-link">
              <span className="hide-content">Pretty & Lashed by Shanise</span>
              <div className="big-logo" aria-hidden="true">
              <img alt="Shanise the founder" src={PRETTY} />
              </div>
            </Link>
          </div>
          <nav className="secondary-nav">
            <CartCounter />
          </nav>
        </div>
        <div className="header-container hide-content">
          <div className="content">
            <h1>Products listing</h1>
          </div>
        </div>
      </header>
    );
  }
}

const mapStateToProps = state => state;

export default connect(mapStateToProps)(ProductsHeader);



// WEBPACK FOOTER //
// ./src/components/Products/ProductsHeader.js